import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';

export const autocompleteStyles = (theme, fieldVariant) => {
  const styles = {
    [FieldVariant.dataRow]: {
      root: {},
    },
    [FieldVariant.form]: {
      root: {
        '& .MuiInputBase-input': {
          minHeight: '1.5rem !important',
        },
        '& .MuiInput-formControl': {
          marginTop: '13px!important',
        },
        '& .MuiAutocomplete-input': {
          paddingBottom: '3.5px!important',
          paddingTop: '5.76px !important',
          minWidth: 'unset!important',
        },
        '& .MuiInputBase-inputAdornedStart': {
          padding: '1px 0 6px!important',
        },
        '& .MuiInputAdornment-positionStart': {
          marginTop: '0!important',
        },
      },
      listbox: {
        fontSize: theme.typography.body2.fontSize,
        width: '100% !important',
      },
      paper: {
        width: 'max-content !important',
        maxWidth: 'min(calc(100dvw - 5rem), 400px)',
        overflow: 'auto',
        '& .MuiAutocomplete-loading': {
          fontSize: '0.875rem!important',
        },
      },
    },
  };

  return styles[fieldVariant];
};
